module.exports = __webpack_public_path__ + "img/vector.5df80d9d.svg";